<script lang="ts">
  import {writable} from 'svelte/store';
  import TextColorPallete from './TextColorPallete.svelte';
  import {onMount} from 'svelte';
  import {recap} from '@/store';
  import {events} from '../RemotionElements/Util';

  const colorPaletteStore = writable(['#FFFFFF']);

  function updateColor(detail: {color: string}, index: number) {
    colorPaletteStore.update(value => {
      value[index] = detail.color;
      return value;
    });

    recap.update(value => {
      const composition = value.composition;
      for (let i = 0; i < composition.length; i++) {
        const element = composition[i];
        if (element.type === 'subtitle-element') {
          if (!element.properties) element.properties = {};
          element.properties.textColor = detail.color;
          composition[i] = element;
          console.log(detail, 'RECAP UPDATE COLOR');
        }
      }
      value.composition = composition;

      dispatchEvent(new Event(events.compositionUpdate));
      return value;
    });
  }

  onMount(() => {
    const composition = $recap.composition;

    let subtitleElement;

    for (let i = 0; i < composition.length; i++) {
      const element = composition[i];
      if (element.type === 'subtitle-element') subtitleElement = element;
    }

    let color;

    if (subtitleElement) {
      const properties = subtitleElement.properties;
      if (properties) color = properties.textColor;
    }

    updateColor({color: color || '#FFFFFF'}, 0);
  });
</script>

<div class="w-full pb-4">
  <span class="pb-2 font-medium">Text Color</span>
  <div class="flex h-12 w-full overflow-hidden rounded-lg border">
    {#each $colorPaletteStore as color, i}
      <TextColorPallete {color} colors={$colorPaletteStore} on:color-change={event => updateColor(event.detail, i)} />
    {/each}
  </div>
</div>
